import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Button, Divider, Space, Typography } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { RowMd } from '../../../styles';
import AnimOpacity from '../../UI/Anim/AnimOpacity';
import CourtPayment from './CourtPayment';
import Fee from './Fee';
import Wps from './Wps';

const { Title, Text } = Typography;

const WpsFee = ({  wpsVisible, setWpsVisible  }:{
  setWpsVisible:(wpsVisible:boolean)=>void,
  wpsVisible: boolean,
}) => {
  const { t } = useTranslation();
  return (
    <div id="wps">
      <Divider />
      <Title level={3}>{t('wpsFee.title')}</Title>
      <Text type="secondary">{t('wpsFee.desc')}</Text>
      <RowMd>
        <Space>
          <Button
            type='primary'
            icon={wpsVisible ? <DownOutlined /> : <UpOutlined />}
            onClick={() =>
              setWpsVisible(!wpsVisible)}
          >
            {t('wpsFee.check')}
          </Button>
        </Space>
      </RowMd>
      {wpsVisible ? (
        <AnimOpacity>
          <Wps />
          <CourtPayment />
          <Fee />
        </AnimOpacity>
      )
        : null}
    </div>
  );
};


export default WpsFee;